import { cn } from "./lib/cn";

export interface FlowConnectorProps {
  /**
   * Araya aşama ekleme eylemi. Verilmezse konektör yalnız görsel bağ çizer — akışın
   * SONUNDAKİ bağ gibi, araya ekleme kavramının olmadığı yerlerde.
   */
  onInsert?: () => void;
  /** Düğmenin erişilebilir adı. ⚠ `onInsert` varsa ZORUNLU — adsız düğme okunamaz. */
  insertLabel?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * İKİ AŞAMA ARASINDAKİ BAĞ — ve oraya aşama ekleme yeri (Dinamik Workflow Kart 7).
 *
 * ### ⚠ Konektör bir ÇİZGİ DEĞİL, bir EYLEM YERİ
 *
 * UI/UX §32 iki aşama arasına eklemeyi "hızlı" istiyor. Ekleme düğmesini listenin altında
 * tek bir yere koysaydık, kullanıcı aşamayı ekledikten SONRA yerini düzeltmek zorunda
 * kalırdı — "araya ekle" niyeti iki adıma bölünürdü.
 *
 * ### ⚠ Çizgi ekran okuyucuya OKUNMUYOR
 *
 * Görsel bağ `aria-hidden`: "aşağı ok" diye okunması kullanıcıya hiçbir şey söylemez, sırayı
 * zaten liste yapısı taşıyor. Okunan tek şey ekleme düğmesinin kendi adı.
 *
 * ### ⚠ Bu bileşen SIRA BİLMİYOR
 *
 * Kaçıncı aşamadan sonra olduğunu, eklemenin serbest olup olmadığını çağıran bilir. Burada
 * "yayınlanmışsa ekleme kapalı" gibi bir kural olsaydı, aynı kural hem sayfada hem bileşende
 * yaşar ve bir gün ayrışırdı.
 */
export function FlowConnector({
  onInsert,
  insertLabel,
  disabled = false,
  className,
}: FlowConnectorProps) {
  return (
    <div className={cn("flex flex-col items-center gap-1 py-1", className)}>
      <span aria-hidden="true" className="block h-4 w-px bg-border-default" />
      {onInsert ? (
        <button
          type="button"
          onClick={onInsert}
          disabled={disabled}
          aria-label={insertLabel}
          className={cn(
            "flex size-6 items-center justify-center rounded-full border border-border-default",
            "text-fg-muted transition-colors",
            "hover:border-primary hover:text-primary",
            "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
            "disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-border-default disabled:hover:text-fg-muted",
          )}
        >
          <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="size-3.5">
            <path d="M10 4a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4H5a1 1 0 1 1 0-2h4V5a1 1 0 0 1 1-1Z" />
          </svg>
        </button>
      ) : null}
      <span aria-hidden="true" className="block h-4 w-px bg-border-default" />
    </div>
  );
}
